import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SeasonProvider } from './contexts/SeasonContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AIMatchLab from './pages/AIMatchLab';
import SimulationLab from './pages/SimulationLab';
import VenueIntelligence from './pages/VenueIntelligence';
import PredictionHistory from './pages/PredictionHistory';
import TeamsPage from './pages/TeamsPage';
import AdminPanel from './pages/AdminPanel';
import LiveMatchPage from './pages/LiveMatchPage';
import StandingsPage from './pages/StandingsPage';
import MatchupDashboard from './pages/MatchupDashboard';
import PlayersPage from './pages/PlayersPage';
import PlayerProfile from './pages/PlayerProfile';
import GodModeAnalytics from './pages/GodModeAnalytics';
import ModelPerformance from './pages/ModelPerformance';
import GlobalPredictions from './pages/GlobalPredictions';
import VimalDashboard from './pages/VimalDashboard';
import SocialMediaHub from './pages/SocialMediaHub';
import RealtimeCommand from './pages/RealtimeCommand';
import SeasonPreview from './pages/SeasonPreview';
import FantasyXI from './pages/FantasyXI';
import IntelligencePipeline from './pages/IntelligencePipeline';
import ExternalIntelligence from './pages/ExternalIntelligence';
import NotificationAlerts from './pages/NotificationAlerts';
import ModelRetrainingDashboard from './pages/ModelRetrainingDashboard';
import PipelineHealth from './pages/PipelineHealth';
import { Toaster } from './components/ui/sonner';
import './App.css';

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen bg-[#050505] flex items-center justify-center">
                <div className="w-10 h-10 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return <Layout><SeasonProvider>{children}</SeasonProvider></Layout>;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
                    <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
                    <Route path="/match-lab" element={<ProtectedRoute><AIMatchLab /></ProtectedRoute>} />
                    <Route path="/ai-match-lab" element={<ProtectedRoute><AIMatchLab /></ProtectedRoute>} />
                    <Route path="/simulation" element={<ProtectedRoute><SimulationLab /></ProtectedRoute>} />
                    <Route path="/venue-intelligence" element={<ProtectedRoute><VenueIntelligence /></ProtectedRoute>} />
                    <Route path="/venues" element={<ProtectedRoute><VenueIntelligence /></ProtectedRoute>} />
                    <Route path="/prediction-history" element={<ProtectedRoute><PredictionHistory /></ProtectedRoute>} />
                    <Route path="/history" element={<ProtectedRoute><PredictionHistory /></ProtectedRoute>} />
                    <Route path="/teams" element={<ProtectedRoute><TeamsPage /></ProtectedRoute>} />
                    <Route path="/players" element={<ProtectedRoute><PlayersPage /></ProtectedRoute>} />
                    <Route path="/players/:playerId" element={<ProtectedRoute><PlayerProfile /></ProtectedRoute>} />
                    <Route path="/live" element={<ProtectedRoute><LiveMatchPage /></ProtectedRoute>} />
                    <Route path="/standings" element={<ProtectedRoute><StandingsPage /></ProtectedRoute>} />
                    <Route path="/matchups" element={<ProtectedRoute><MatchupDashboard /></ProtectedRoute>} />
                    <Route path="/god-mode" element={<ProtectedRoute><GodModeAnalytics /></ProtectedRoute>} />
                    <Route path="/global-predictions" element={<ProtectedRoute><GlobalPredictions /></ProtectedRoute>} />
                    <Route path="/model-performance" element={<ProtectedRoute><ModelPerformance /></ProtectedRoute>} />
                    <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
                    <Route path="/social-hub" element={<ProtectedRoute><SocialMediaHub /></ProtectedRoute>} />
                    <Route path="/season-preview" element={<ProtectedRoute><SeasonPreview /></ProtectedRoute>} />
                    <Route path="/fantasy" element={<ProtectedRoute><FantasyXI /></ProtectedRoute>} />
                    <Route path="/intelligence-pipeline" element={<ProtectedRoute><IntelligencePipeline /></ProtectedRoute>} />
                    <Route path="/external-intelligence" element={<ProtectedRoute><ExternalIntelligence /></ProtectedRoute>} />
                    <Route path="/notifications" element={<ProtectedRoute><NotificationAlerts /></ProtectedRoute>} />
                    <Route path="/model-retraining" element={<ProtectedRoute><ModelRetrainingDashboard /></ProtectedRoute>} />
                    <Route path="/pipeline-health" element={<ProtectedRoute><PipelineHealth /></ProtectedRoute>} />
                    <Route path="/realtime" element={<ProtectedRoute><RealtimeCommand /></ProtectedRoute>} />
                    <Route path="/vimal-dashboard" element={<ProtectedRoute><VimalDashboard /></ProtectedRoute>} />
                    <Route path="/vimal" element={<ProtectedRoute><VimalDashboard /></ProtectedRoute>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Toaster richColors position="top-right" />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
